import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';

const shimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

const SkeletonBase = styled.div(({ theme }) => ({
    animation: `${shimmer} 2s ease-in-out infinite`,
    background:
        'linear-gradient(90deg, var(--color-skeleton-base) 0%, var(--color-skeleton-highlight) 50%, var(--color-skeleton-base) 100%)',
    backgroundSize: '1000px 100%',
    borderRadius: theme.borderRadius.m,
}));

const SkeletonDetailTitle = styled(SkeletonBase)(({ theme }) => ({
    height: theme.spacing['4xl'],
    marginBottom: theme.spacing['3xl'],
    marginTop: theme.spacing.xxl,
    width: '50%',
}));

const SkeletonDetailDescription = styled(SkeletonBase)(({ theme }) => ({
    height: '20vh',
    marginBottom: theme.spacing['6xl'],
    minHeight: '150px',
    width: '100%',
}));

const SkeletonProficiencyTitle = styled(SkeletonBase)(({ theme }) => ({
    height: theme.spacing.xxl,
    marginBottom: theme.spacing.m,
    marginTop: theme.spacing.l,
    width: '10%',
}));

const SkeletonProficiencyDescription = styled(SkeletonBase)(({ theme }) => ({
    height: theme.spacing['10xl'],
    marginBottom: theme.spacing.xxl,
    marginLeft: theme.spacing['7xl'],
    width: '90%',
}));

export const SkillDetailsLoadingSkeleton: FunctionComponent = () => {
    return (
        <div style={{ width: '100%' }}>
            <SkeletonDetailTitle />
            <SkeletonDetailDescription />
            <div>
                {[1, 2, 3, 4].map((index) => (
                    <div key={index}>
                        <SkeletonProficiencyTitle />
                        <SkeletonProficiencyDescription />
                    </div>
                ))}
            </div>
        </div>
    );
};
